import { render, staticRenderFns } from "./AdGuardTopDomains.vue?vue&type=template&id=71d7fa29&"
import script from "./AdGuardTopDomains.vue?vue&type=script&lang=js&"
export * from "./AdGuardTopDomains.vue?vue&type=script&lang=js&"
import style0 from "./AdGuardTopDomains.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports